"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const router_1 = require("next/router");
const Journey_1 = require("../../lib/Journey");
const Spinner_1 = __importDefault(require("../Animation/Spinner"));
const JourneyAppContext_1 = require("../../contexts/JourneyAppContext");
const AuthWall = ({ children }) => {
    const { authed } = react_1.useContext(JourneyAppContext_1.JourneyAppContext);
    const AuthDeniedComponent = Journey_1.Journey.config.authDeniedComponent;
    const route = router_1.useRouter();
    const isAuthedRoute = !!Journey_1.Journey.config.authedRoutes.find((authedRoute) => authedRoute === route.route);
    const loading = authed === 'loading';
    const denied = !loading && authed !== true;
    if (!isAuthedRoute) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading && react_1.default.createElement(Spinner_1.default, null),
        denied && react_1.default.createElement(AuthDeniedComponent, null),
        !denied && !loading ? react_1.default.createElement(react_1.default.Fragment, null, children) : null));
};
exports.default = AuthWall;
